'use strict';

angular.module('mobile-apps')
	.directive('displayTag',['$compile', '$state', '$stateParams', '$rootScope', function($compile, $state, $stateParams, $rootScope) {
		return {
			scope:
			{
				entryId : '@', // Optional
                entryKey: '@',
				data : '=',
				tagCategories : '='
			},
			templateUrl: 'modules/mobile-apps/views/display-tag.client.directive.html',
            controller: ['$scope', 'MobileApps', function ($scope, MobileApps) {
			    MobileApps.getEntryKey({ mobileAppId: $stateParams.mobileAppId, entryId: $scope.entryId }, function (response) {
			        $scope.entryKey = response.entryKey;
			    });
            }],

			link: function (scope, elem, attrs) {

				scope.selectTag = function(tagId) {
					$state.go('viewLanguage.entry.tag', {
						entryId: scope.entryId,
						languageId: $stateParams.languageId,
						mobileAppId: $stateParams.mobileAppId,
						tagId: tagId
					}, {inherit: true});
				};

				scope.getTagCategoryColor = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.color;
						}
					}
				};

                scope.getTagTypeIconClass = function(){
                    if(!scope.entryKey) return '';

                    if(scope.data.automaticLanguageEntryIds && scope.data.automaticLanguageEntryIds.includes(scope.entryKey)) {
                        return 'fa fa-sync fa-xs';
                    }
                    if(scope.data.fuzzyLanguageEntryIds && scope.data.fuzzyLanguageEntryIds.includes(scope.entryKey)) {
                        return 'fa fa-question fa-xs orange-color';
                    }

                    return '';
                };
			}
		};
	}]);
